import React from 'react';
import classNames from 'classnames';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { IncomeSalaryPayStubDetailsAttachmentMobile } from './IncomeSalaryPayStubDetailsAttachmentMobile';
import { IncomeSalaryPayStubDetailsAttachmentDesktop } from './IncomeSalaryPayStubDetailsAttachmentDesktop';

const useStyles = buildUseStyles('IncomeSalaryPayStubDetailsLayout', (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(10),
  },
  rootMobile: {
    paddingLeft: 0,
  },
  container: {
    padding: theme.spacing(0, 3),
    display: 'flex',
    justifyContent: 'center',
    maxWidth: theme.dimensions.xxl,
    width: '100%',
    gap: '32px',
  },
  containerMobile: {
    marginLeft: 0,
  },
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: '16px',
    maxWidth: 'min(100%, 400px)',
    alignItems: 'center',
    flexShrink: 0,
  },
}));

export const IncomeSalaryPayStubDetailsLayout = () => {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();

  return (
    <>
      <div className={classNames(classes.root, { [classes.rootMobile]: isMobile })}>
        <div className={classNames(classes.container)}>
          <div
            className={classNames(classes.formColumn)}
          >
            <SurveyStepHeader
              title={resource.attr('title')}
              subtitle={resource.attr('subtitle')}
              textAlign={'left'}
            />
            <IncomeSalaryPayStubDetailsAttachmentMobile />
            <MetaControlField attr={'annualGross'} />
            <MetaControlField attr={'frequency'} />
            <MetaControlField attr={'grossEarnings'} />
            <MetaControlField attr={'netEarnings'} />
          </div>
          <IncomeSalaryPayStubDetailsAttachmentDesktop />
        </div>
      </div>
      <SurveyStepFooter onSubmit={onSubmitMetaForm} />
    </>
  );
};
